import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'

export const AboutCard = ({
  header,
  text,
  image,
  width = 'auto',
  imageWidth = 470,
  imageHeight = 298,
}: {
  header: string
  text: string
  image: string
  imageWidth?: number
  imageHeight?: number
  width?: string
}) => (
  <div key={header} className='mc-p-6' style={{ width }}>
    <Image
      className='mc-corners--lg mc-m-auto'
      src={image}
      width={imageWidth}
      height={imageHeight}
    />
    <div className='mc-mx-auto mc-my-6' style={{ maxWidth: '470px' }}>
      <h1 className='mc-mt-8 mc-mb-6 mc-font-headline3'>{header}</h1>
      <h2 className='mc-text-color--tint'>{text}</h2>
    </div>
  </div>
)

export const AboutCards = () => {
  const { t } = useTranslation('@mc/next')
  const cards = [
    {
      image: 'https://static.masterclass.com/for-business-ms.png',
      header: t('forBusiness.aboutSection.driveBusiness'),
      text: t('forBusiness.aboutSection.driveBusinessText'),
    },
    {
      image: 'https://static.masterclass.com/for-business-lh.png',
      header: t('forBusiness.aboutSection.inspireLifelong'),
      text: t('forBusiness.aboutSection.inspireLifelongText'),
    },
    {
      image: 'https://static.masterclass.com/for-business-ak.png',
      header: t('forBusiness.aboutSection.storytelling'),
      text: t('forBusiness.aboutSection.storytellingText'),
    },
    {
      image: 'https://static.masterclass.com/for-business-everyone.png',
      header: t('forBusiness.aboutSection.learningForEveryone'),
      text: t('forBusiness.aboutSection.learningForEveryoneText'),
    },
  ]

  return cards.map((card) => <AboutCard key={card.header} {...card} />)
}
